const vapidKey = process.env.VAPID_KEY
const swPath = process.env.SW_PATH
const FirebaseConfig = process.env.FIREBASE_CONFIG

export { vapidKey, swPath, FirebaseConfig }
